import { IStorageService } from "@core/storage";
import { PageCacheKey } from "@modules/basic/page";
import { AnonymousPageObjectTreeService } from "@modules/basic/page/anonymous/anonymous-page-object-tree.service";
import { Icatalog, IObjectTreeService, IbreadcrumbCatalog, IcatalogsMap, IConstCatalog, Catalog, ICatalogPagePathMapItem } from ".";

export class CatalogObjectTree extends AnonymousPageObjectTreeService {
    public static readonly $inject: Array<string> = ["storageService"];
    catalogs: Array<Catalog>;
    // 当前分类
    currentCatalog: ICatalogPagePathMapItem | undefined;

    // 用于分类页移动端,固定类目名称所在区域
    productsHeaderFixed: boolean;
    // url参数（店铺id（个人中心--》店铺产品列表--》添加店铺产品））
    urlParameter: string;
    // 产品类目映射数据
    catalogsMap: IcatalogsMap;

    defaultCatalog: string;

    customizePath: string;

    appTag?: string;
    appName?: string;
    // 网站默认类目Id
    defaultCatalogId: number;
    catalogPagePathMap?: Map<string, ICatalogPagePathMapItem>;
    defaultCatalogPagePath?:string ;

    // 类目类型
    // catalogType:string;

    constructor(
        public storageService: IStorageService<PageCacheKey>
    ) {
        super();

    }
}
